import { type ReactNode } from 'react'
import { Route, Switch } from 'react-router-dom'

import { PrivateRoute } from 'core/ui/components/private-route/PrivateRoute'

import { AwardedProposalConfirmationPage } from './AwardedProposalConfirmationPage'
import { AwardedProposalPage } from './AwardedProposalPage'
import { RfpProvider } from './contexts/RfpContext'
import { ProposalPage } from './ProposalPage'
import { RfpHistoryPage } from './RfpHistoryPage'

type RfpPageProps = {
  match: {
    path: string
  }
  historyPage?: ReactNode
}

export default function RfpPage({ match, historyPage }: RfpPageProps): JSX.Element {
  const { path } = match

  return (
    <RfpProvider>
      <Switch>
        <Route
          path={`${path}/:id/feedback`}
          render={props => <ProposalPage {...props} disabled />}
          exact
        />
        <Route path={`${path}/:id`} component={ProposalPage} exact />
        <Route path={`${path}/:id/award`} component={AwardedProposalPage} exact />
        <Route
          path={`${path}/:id/award/confirmation`}
          component={AwardedProposalConfirmationPage}
          exact
        />
        {historyPage ? (
          <Route path={`${path}/`}>{historyPage}</Route>
        ) : (
          <PrivateRoute path={`${path}/`} component={RfpHistoryPage} />
        )}
      </Switch>
    </RfpProvider>
  )
}
